<template>
  <div class="m-page">
    <!--<steps :dataList="dataList" :activeIndex="1"></steps>-->
    <div class="m-cont">
      <!-- 套餐体检项目-->
      <div v-if="Object.keys(productData).length">
        <Item class="productName">
          <slot slot="item-content">
            <div>
              <img src="../../../public/images/product/icon.png" alt="" />
              <h2>{{ productData.name }}</h2>
            </div>
            <span
              >￥<i>{{ productProjects.priceTotal }}</i></span
            >
          </slot>
        </Item>
        <ul class="m-optional">
          <li
            class="item-main"
            v-for="(item, index) in packageProjects"
            :key="index"
          >
            <div
              class="m-item"
              :class="
                replacedProjects.includes(item.projectId) ? 'del-line' : ''
              "
              @click.stop="showProjectDetail(item)"
            >
              <div>
                <em></em
                ><span class="m-text no-recommend"
                  >{{ index + 1 }}、{{ item.item }}</span
                >
              </div>
              <div class="m-num">
                <span v-show="showPackagePrice"
                  >{{ item.discountPrice }}元 &nbsp;&nbsp;&nbsp;&nbsp;</span
                >
                <i class="icon icon-arrow-right" v-show="!showPackagePrice"></i>
              </div>
            </div>
          </li>
          <li
            class="item-main"
            v-for="(item, index) in parckagemTransformList"
            :key="index + 't'"
          >
            <div
              class="m-item"
              :class="
                replacedProjects.includes(item.projectId) ? 'del-line' : ''
              "
              @click.stop="showProjectDetail(item)"
            >
              <div>
                <em></em
                ><span class="m-text no-recommend"
                  >{{ index + packageProjects.length + 1 }}、{{
                    item.item
                  }}</span
                >
              </div>
              <div class="m-num">
                <i class="icon icon-arrow-right" v-show="!showPackagePrice"></i>
              </div>
            </div>
            <ul class="m-optional">
              <li
                class="item-main"
                v-for="(obj, $index) in item.childernList"
                :key="$index + 'ts'"
                v-if="obj.num > 0"
              >
                <div
                  class="m-item"
                  :class="
                    replacedProjects.includes(obj.projectId) || obj.reduce
                      ? 'del-line'
                      : ''
                  "
                >
                  <div>
                    <em></em
                    ><span class="m-text no-recommend"
                      >{{ index + packageProjects.length + 1 }}.{{
                        $index + 1
                      }}、{{ obj.item }} {{ obj.num > 1 ? "*" + obj.num : "" }}
                    </span>
                  </div>
                  <div class="m-num" @click.stop="showProjectDetail(obj)">
                    <span v-show="showPackagePrice"
                      >{{ obj.projectPrice }}元 &nbsp;&nbsp;&nbsp;&nbsp;</span
                    >
                    <i
                      v-show="!showPackagePrice"
                      class="icon icon-arrow-right"
                    ></i>
                  </div>
                </div>
              </li>
            </ul>
          </li>
        </ul>
        <Item class="showProject" @click.native="showProject = !showProject">
          <slot slot="item-content">
            <i
              class="icon"
              :class="[
                { 'icon-arrow-top': showProject },
                { 'icon-arrow-bottom': !showProject },
              ]"
            ></i>
          </slot>
        </Item>
      </div>
      <div class="affix-block" v-show="baseProjectList.length > 0">
        <affix
          relative-element-selector="#base-project"
          :offset="{ top: 48, bottom: 0 }"
        >
          <div class="m-title">
            <i></i
            ><span
              >基础项目（{{ baseProjectList.length }}项）
              <i
                class="icon icon-iconfontquestion assertive"
                @click="showRemind = true"
              ></i
            ></span>
            <div class="m-btn" v-show="!deleteMode.custom">
              <button
                :class="{ 'btn-done': deleteMode.base }"
                @click="deleteModeClicked('base')"
                v-if="deletBase && !deleteMode.base"
              >
                {{ deleteMode.base ? "完成" : "删除" }}
              </button>
              <button
                v-show="!deleteMode.base && revertProjectList.length > 0"
                @click.stop="revertBaseProject"
              >
                撤回
              </button>
            </div>
          </div>
        </affix>
      </div>
      <ul
        id="base-project"
        class="m-optional"
        v-show="isBasePackageProject.length > 0"
      >
        <li
          class="item-main"
          v-for="(project, index) in isBasePackageProject"
          :key="index"
        >
          <div class="m-item" @click.stop="showProjectDetail(project)">
            <div>
              <em
                ><i
                  v-show="deleteMode.base && project.delectable !== '0'"
                  class="icon icon-del2"
                  @click.stop="deleteProject(project)"
                ></i></em
              ><span class="m-text no-recommend">{{ project.item }}</span>
            </div>
            <div class="m-num">
              <span v-if="showProjectPrice === '1'">{{ project.price }}元</span
              ><i class="icon icon-arrow-right"></i>
            </div>
          </div>
          <special-alert
            v-if="project.addWarning === '1' && project.warningInfo"
            >{{ project.warningInfo }}</special-alert
          >
        </li>
        <li
          class="item-main"
          v-for="(project, index) in addBase"
          :key="project.id + index"
        >
          <div class="m-item" @click.stop="showProjectDetail(project)">
            <div>
              <em
                ><i
                  v-show="deleteMode.base && project.delectable !== '0'"
                  class="icon icon-del2"
                  @click.stop="deleteProject(project)"
                ></i></em
              ><span class="m-text no-recommend">{{ project.item }}</span>
            </div>
            <div class="m-num">
              <span v-if="showProjectPrice === '1'">{{ project.price }}元</span
              ><i class="icon icon-arrow-right"></i>
            </div>
          </div>
          <special-alert
            v-if="project.addWarning === '1' && project.warningInfo"
            >{{ project.warningInfo }}</special-alert
          >
        </li>
        <li>
          <div class="m-total">
            <span class="title">小计</span><span class="tag">￥</span
            >{{ priceInfo.baseProjectPrice }}
          </div>
        </li>
      </ul>
      <!-- 自选项目开始-->
      <div
        class="affix-block"
        v-if="
          $route.params.type === 'custom' ||
          $route.params.type === 'customize' ||
          productData.projectSelectOpt === 1
        "
      >
        <affix
          relative-element-selector="#custom-project"
          :offset="{ top: 48, bottom: 0 }"
        >
          <div class="m-title">
            <i></i><span>推荐项目（{{ projectListList.length }}项）</span>
            <div class="m-btn" v-show="!deleteMode.base">
              <button
                :class="{ 'btn-done': deleteMode.custom }"
                @click="deleteModeClicked('custom')"
              >
                {{ deleteMode.custom ? "完成" : "删除" }}
              </button>
              <button
                class="assertive"
                v-show="!deleteMode.custom"
                @click="addProjectClicked"
              >
                加项
              </button>
            </div>
          </div>
        </affix>
      </div>
      <ul id="custom-project" class="m-optional">
        <template v-for="(item, index) in checkedProjectByGroup">
          <template v-if="item.children && item.children.length > 0">
            <li class="m-item no-recommend" :key="'p' + index">
              <div class="group-text">
                <img src="../../../public/images/filesIcon.png" alt="" /><em
                  ><i
                    v-show="deleteMode.custom"
                    class="icon icon-del2"
                    @click.stop="deleteClassGroupProject(item)"
                  ></i></em
                ><span class="m-text">{{ item.item }}</span>
              </div>
              <div class="m-num group-price" v-if="showProjectPrice === '1'">
                <span
                  >{{ getClassGroupPrice(item) }}元
                  <small v-if="hasRepeatProject(item)">(除重复项)</small></span
                >
                <i
                  class="icon icon-arrow-right"
                  @click="jumpCurrentClassGroupClicked(item.id)"
                ></i>
              </div>
            </li>
            <div
              class="hasq"
              v-if="item.counditionInfoList && item.counditionInfoList.length"
            >
              推荐理由：<span
                v-for="(coun, index) in item.counditionInfoList"
                class="assertive"
                :key="'coun' + coun.id"
                >{{ coun.name
                }}{{
                  index + 1 < item.counditionInfoList.length ? "、" : ""
                }}</span
              >
            </div>
            <ul class="m-optional m-group" :key="index">
              <li
                class="item-main"
                v-for="(project, indx) in item.children"
                :key="indx"
              >
                <div
                  class="m-item"
                  :class="{ 'no-recommend': project.recommendable !== 1 }"
                  @click.stop="showProjectDetail(project)"
                >
                  <div>
                    <em
                      ><i
                        v-show="deleteMode.custom"
                        class="icon icon-del2"
                        @click.stop="deleteProject(project)"
                      ></i
                    ></em>
                    <div class="m-text-box">
                      <span class="m-text">{{ project.item }}</span>
                      <span v-if="project.recommendable !== 1" class="m-hot"
                        >加项</span
                      >
                    </div>
                  </div>
                  <div class="m-num">
                    <span
                      v-if="
                        checkedProjectByRepeat[project.id] ===
                          `${item.id}-${project.id}` && showProjectPrice === '1'
                      "
                      >{{ project.price }}元</span
                    >
                    <span
                      v-if="
                        checkedProjectByRepeat[project.id] !==
                        `${item.id}-${project.id}`
                      "
                      >不重复计价</span
                    >
                    <i class="icon icon-arrow-right"></i>
                  </div>
                </div>
                <special-alert
                  v-if="project.addWarning === '1' && project.warningInfo"
                  >{{ project.warningInfo }}
                </special-alert>
              </li>
            </ul>
          </template>
          <li class="item-main" v-else :key="index">
            <div
              class="m-item"
              :class="{ 'no-recommend': item.recommendable !== 1 }"
              @click.stop="showProjectDetail(item)"
            >
              <div>
                <em
                  ><i
                    v-show="deleteMode.custom"
                    class="icon icon-del2"
                    @click.stop="deleteProject(item)"
                  ></i
                ></em>
                <div class="m-text-box">
                  <span class="m-text">{{ item.item }}</span>
                  <span v-if="item.recommendable !== 1" class="m-hot"
                    >加项</span
                  >
                </div>
              </div>
              <div class="m-num">
                <span v-if="showProjectPrice === '1'">{{ item.price }}元</span
                ><i class="icon icon-arrow-right"></i>
              </div>
            </div>
            <special-alert v-if="item.addWarning === '1' && item.warningInfo">{{
              item.warningInfo
            }}</special-alert>
          </li>
        </template>
        <li
          class="m-item m-item-alert"
          v-if="
            projectListList.length <= 0 &&
            ($route.params.type === 'custom' ||
              productData.projectSelectOpt === 1)
          "
        >
          <span>无自选项目</span>
        </li>
        <li v-if="projectListList.length > 0">
          <div class="m-total">
            <span class="title">小计</span><span class="tag">￥</span
            >{{ priceInfo.customProjectPrice }}
          </div>
        </li>
      </ul>
    </div>
    <!-- 自选项目结束-->

    <!-- 所需耗材开始-->
    <div class="affix-block" v-if="materialProjectList.length > 0">
      <affix
        relative-element-selector="#material-project"
        :offset="{ top: 48, bottom: 0 }"
      >
        <div class="m-title">
          <i></i
          ><span>关联检查/耗材（{{ materialProjectList.length }}项）</span>
        </div>
      </affix>
    </div>
    <ul id="material-project" class="m-optional">
      <li
        class="item-main"
        v-for="(project, index) in materialProjectList"
        :key="index"
        v-if="!showConsumable || (showConsumable && index <= 1)"
      >
        <div class="m-item" @click.stop="showProjectDetail(project)">
          <div>
            <em></em><span class="m-text no-recommend">{{ project.item }}</span>
          </div>
          <div class="m-num">
            <span v-if="showProjectPrice === '1'"
              >{{ project.price }}元 x {{ project.count || 1 }}</span
            ><i class="icon icon-arrow-right"></i>
          </div>
        </div>
        <special-alert v-if="project.addWarning && project.warningInfo">{{
          project.warningInfo
        }}</special-alert>
      </li>
      <li>
        <div class="m-total" v-if="materialProjectList.length > 0">
          <span class="title">小计</span><span class="tag">￥</span
          >{{ priceInfo.materialProjectPrice }}
        </div>
      </li>
      <li
        class="item-main consumable-show"
        v-if="materialProjectList.length > 2"
      >
        <Item
          class="showProject"
          @click.native="showConsumable = !showConsumable"
        >
          <slot slot="item-content">
            <i
              class="icon"
              :class="[
                { 'icon-arrow-top': !showConsumable },
                { 'icon-arrow-bottom': showConsumable },
              ]"
            ></i>
          </slot>
        </Item>
      </li>
    </ul>
    <div class="m-foot">
      <div class="m-info">
        <p class="m-info-left">
          需支付：<span
            >￥<b>{{ priceInfo.priceTotal }}</b></span
          >
        </p>
      </div>
      <div
        class="m-next"
        :class="{ 'btn-done': deleteMode.custom || deleteMode.base }"
        v-if="$route.query.type && $route.query.type === 'edit'"
        @click.stop="edit()"
      >
        {{ deleteMode.custom || deleteMode.base ? "完成" : "提交" }}
      </div>
      <div
        class="m-next"
        :class="{ 'btn-done': deleteMode.custom || deleteMode.base }"
        v-else
        @click.stop="nextClicked()"
      >
        {{ deleteMode.custom || deleteMode.base ? "完成" : "下一步" }}
      </div>
    </div>
    <div
      class="inquiry"
      v-if="
        $store.state.project.productRecommend.length === 0 &&
        productData.projectSelectOpt === 1 &&
        sysCenter.individuationOpt !== 0
      "
    >
      使用<span @click="getPrevious()">个体化检前问诊</span
      >，在该套餐基础上，让添加的项目更符合您的体检需求
    </div>
    <hint
      :showModal="hintShow"
      :showTxt="hintText"
      :btnList="btnList"
      @btnClick="closeHint"
      :showTitle="showTitle"
    ></hint>
    <hint
      :showModal="isHint07"
      showTxt="体检者基本信息及体检项目，本人已知晓并确认无误！若因故意隐瞒等相关情况，造成后果，本人承担相应法律责任！"
      :btnList="['确认']"
      @btnClick="closeHint07"
      showTitle="提示"
    ></hint>
    <delete-recommend
      :showModal="showDeleteRecommend"
      :project="delRecommendProject"
      @btnClose="closeDeleteRecommend"
    ></delete-recommend>
    <project-description
      :showModal="showProjectModal"
      :project="projectDetail"
      @iconClicked="closeProjectDetail"
      @maskClicked="closeProjectDetail"
    ></project-description>
    <date-picker
      ref="datePicker"
      v-if="$route.query.sysCenterId !== '00-7'"
      v-model="dateState"
      :dateList="dateList"
      @getTime="getTime"
      @specialHandler="specialHandler"
    ></date-picker>
    <date-picker-time
      v-else-if="$route.query.sysCenterId === '00-7'"
      ref="datePickerTime"
      v-model="dateState"
      :dateList="dateList"
      :dateTimeList="dateTimeList"
      @getTime="getTime"
    ></date-picker-time>
    <delete-project-hint
      @lookExplain="lookExplain"
      :showModal="showDelectProject"
      :recordCode="recordCode"
      :deleteProjects="deleteProjects"
      @btnClick="deleteProjectBtnClick"
    ></delete-project-hint>
    <disclaimer-that
      :showModal="showDisclaimer"
      :disclaimer="sysCenter.disclaimer"
      :recordCode="recordCode"
      @btnClose="closeDisclaimer"
    ></disclaimer-that>
    <span
      class="historyProject icon icon-zuji"
      @click="getHistoryProject(true)"
      v-show="showHistoryIcon"
    >
    </span>
    <remind
      :hint="remindData"
      :showModal="showRemind"
      @close="showRemind = false"
    ></remind>
    <van-actionsheet
      class="historyProjectBox"
      title="放弃的体检项目"
      v-model="showHistory"
      :overlay="true"
    >
      <div class="projectBox">
        <div
          class="projectItem"
          v-for="project in itThrough"
          :key="'histroy' + project.id"
          @click="selectDeleteProject(project)"
        >
          <div class="row flex-between">
            <div class="col-1">
              <i
                class="icon"
                :class="
                  project.select
                    ? 'icon-newxuanzhongduoxuan assertive'
                    : 'icon-duoxuankuang1'
                "
              ></i>
            </div>
            <div :class="showProjectPrice === '1' ? 'col-8 ' : 'col-10'">
              <div class="row">
                <div class="col-12 overflow-hidden">
                  <div class="row">
                    <span
                      class="m-text no-recommend ellipsis"
                      :class="{ 'col-5': project.code !== 'delete' }"
                      >{{ project.item }}</span
                    >
                    <span
                      v-if="project.code !== 'delete'"
                      class="notDelete col-auto"
                      >已选同类检查</span
                    >
                  </div>
                </div>
              </div>
              <div
                class="row recommendationLevel"
                v-if="
                  project.code === 'delete' && project.star && project.star > 0
                "
              >
                <div class="col-12">
                  <div class="col-auto row-align-center row">
                    推荐等级：
                    <span
                      class="projectStar"
                      :class="'star-' + project.star"
                    ></span>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="text-right"
              :class="showProjectPrice === '1' ? 'col-3 ' : 'col-1'"
            >
              <span v-if="showProjectPrice === '1'">{{ project.price }}元</span
              ><i class="icon icon-arrow-right"></i>
            </div>
          </div>
        </div>
      </div>
      <div class="btns flex-between">
        <button class="close" @click="showHistory = !showHistory">
          取&nbsp;&nbsp;消
        </button>
        <button class="assertive-bg" @click="heckedProjectcs()">
          确&nbsp;&nbsp;认
        </button>
      </div>
    </van-actionsheet>
  </div>
</template>

<script>
import Vue from 'vue'
import Item from '@/components/common/item/index'
import {
  Steps,
  specialAlert,
  projectDescription,
  hint,
  deleteProjectHint,
  disclaimerThat,
  remind
} from '@/components/common'
import { Affix } from 'vue-affix'
import { Loading, ToastMessage } from '@/assets/scripts/helper'
import {
  BEFORE_QUESTION,
  TEST_DATE_BY_PROJECT,
  UPDATE_ORDER_FORCLIENT
} from '@/assets/scripts/api'
import DatePicker from '@/components/common/date/date-picker'
import DatePickerTime from '@/components/common/date/date-picker-time'
//  import historyProjectIcon from '../../../public/images/historyProject.png'
import { Actionsheet } from 'vant'
import deleteRecommend from '@/components/common/deleteProject/deleteRecommend'
//  {{itThrough}}
import { mapGetters, mapState } from 'vuex'
import { copy } from '../../assets/scripts/helper/index'

Vue.use(Actionsheet)
export default {
  components: {
    remind,
    deleteRecommend,
    Steps,
    Affix,
    specialAlert,
    projectDescription,
    Item,
    DatePicker,
    DatePickerTime,
    hint,
    deleteProjectHint,
    disclaimerThat
  },
  data () {
    return {
      remindData: {
        list: [
          {
            title: '基础项目',
            content: '指根据您当前年龄段，满足最基本体检需求的必查项目'
          }
        ]
      },
      showRemind: false,
      delRecommendCode: '',
      showDeleteRecommend: false,
      delRecommendProject: {},
      itThrough: [],
      showHistory: false,
      //        historyProjectIcon,
      isHint07: false, // 00-07提示3
      closeHintCode07: false, // 00-07提示
      showDelectProject: false,
      showDisclaimer: false,
      recordCode: false,
      practicalCode: false,
      deleteProjects: [], //删除的推荐项目
      addProject: [], //新增
      hintText: '',
      showTitle: '',
      btnList: ['我知道了！'],
      upProjectList: [],
      hintShow: false,
      showConsumable: true,
      upgrade: false,
      editData: {},
      editDate: '',
      affirmTime: '',
      hasOthers: false,
      dataList: [
        { name: '确认项目' },
        { name: '确认日期' },
        { name: '预约成功' }
      ],
      dateState: false,
      dateList: [],
      deleteMode: {
        base: false,
        custom: false
      },
      showProjectModal: false,
      showProject: false,
      projectDetail: {}
    }
  },
  beforeRouteEnter (to, from, next) {
    //    console.log(from, to)
    if (from.name === 'appointmentSubmit') {
      next((vm) => {
        vm._data.recordCode = true
      })
    } else {
      next(true)
    }
  },
  computed: {
    ...mapState('project', {
      deleteList: (state) => state.deleteList,
      schemeClass: (state) => state.schemeClass,
      productData: (state) => state.product,
      projectMutexList: (state) => state.projectMutexList,
      productMaterialProjectList: (state) => state.productMaterialProjectList,
      productProjects: (state) => state.productProjects,
      showProjectPrice: (state) => state.showProjectPrice,
      revertProjectList: (state) => state.revertProjectList,
      checkedProjectList: (state) => state.checkedProjectList,
      myRecommendProject: (state) => state.myRecommendProject,
      projectList: (state) => state.projectList,
      historyProject: (state) => state.historyProject,
      initBasePackagePros: (state) => state.initBasePackagePros,
      productRecommend: (state) => state.productRecommend,
      mTransformList: (state) => state.mTransformList,
      rulePackageProsList: (state) => state.rulePackageProsList
    }),
    recommendProjectList () {
      let list = []
      if (Object.keys(this.productRecommend).length) {
        let {
          basePackagePros,
          lastRulePackagePros,
          rulePackagePros,
          thoroughRulePackagePros
        } = this.productRecommend
        list = list.concat(basePackagePros.data || [])
        list = list.concat(lastRulePackagePros.data || [])
        list = list.concat(rulePackagePros.data || [])
        list = list.concat(thoroughRulePackagePros.data || [])
        if (this.rulePackageProsList && this.rulePackageProsList) {
          this.rulePackageProsList.forEach((obj) => {
            if (
              !list.some((project) => {
                return obj.id === project.id
              })
            ) {
              list.push(obj)
            }
          })
        }
      }
      return list
    },
    deletBase () {
      return this.isBasePackageProject.some((obj) => {
        return obj.delectable !== '0'
      })
    },
    addBase () {
      return this.checkedProjectList.filter((obj) => {
        return (
          obj.base === 1 &&
          this.isBasePackageProject.every((item) => {
            return item.id !== obj.id
          })
        )
      })
    },
    showPackagePrice () {
      return this.$store.state.center.sysCenter.showPackagePrice
    },
    showHistoryIcon () {
      return this.historyProject.some((obj) => {
        return !this.checkedProjectList.some((p) => {
          return p.id === obj.id
        })
      })
    },
    isBasePackageProject () {
      var arr = []
      this.baseProjectList.forEach((item) => {
        arr.push(item)
      })
      return arr
    },
    ...mapGetters({
      priceInfo: 'project/priceInfo',
      allProjectList: 'project/projectList',
      baseProjectList: 'project/getBaseProjectList',
      projectListList: 'project/getCustomProjectList',
      materialProjectList: 'project/getMaterialProjectList',
      checkedProjectByGroup: 'project/getCheckedProjectListByClassGroup'
    }),

    sysCenter () {
      return this.$store.state.center.sysCenter
    },
    replacedProjects () {
      if (
        this.projectListList &&
        this.productProjects.replaced &&
        this.productProjects.replaced.projectList
      ) {
        let result = {}
        for (let data of this.productProjects.replaced.projectList) {
          result[data.id] = 1
        }
        return Object.keys(result)
      } else {
        return []
      }
    },
    parckagemTransformListn () {
      let list = []

      let materialList = []
      if (this.mTransformList && this.mTransformList.tree) {
        list = JSON.parse(JSON.stringify(this.mTransformList.tree))
        list.forEach((obj) => {
          obj.childernList.forEach((item, index) => {
            if (this.productMaterialProjectList[item.id] !== undefined) {
              if (item.num > this.productMaterialProjectList[item.id]) {
                materialList.push({
                  num: this.productMaterialProjectList[item.id],
                  reduce: item.num - this.productMaterialProjectList[item.id],
                  id: item.id,
                  parentId: obj.id
                })
              } else {
                materialList.push({
                  num: this.productMaterialProjectList[item.id],
                  reduce: 0,
                  id: item.id,
                  parentId: obj.id
                })
              }
            }
          })
        })
      }
      return materialList
    },
    parckagemTransformList () {
      let list = []
      if (this.showProject) {
        if (this.mTransformList && this.mTransformList.tree) {
          list = JSON.parse(JSON.stringify(this.mTransformList.tree))
          list.forEach((obj) => {
            let newList = []
            obj.childernList.forEach((item, index) => {
              if (
                this.productMaterialProjectList[item.id] !== undefined &&
                this.productMaterialProjectList[item.id] !== item.num
              ) {
                if (item.num > this.productMaterialProjectList[item.id]) {
                  newList.push(
                    ...[
                      Object.assign({}, item, {
                        num: this.productMaterialProjectList[item.id]
                      }),
                      Object.assign({}, item, {
                        num:
                          item.num - this.productMaterialProjectList[item.id],
                        reduce: true
                      })
                    ]
                  )
                } else if (
                  item.num === this.productMaterialProjectList[item.id]
                ) {
                  item.reduce = true
                  newList.push(item)
                }
              } else {
                newList.push(item)
              }
            })
            obj.childernList = newList
          })
        }
      }
      return list
    },
    packageProjects () {
      let result = []
      let packageProjects = this.productData.packageProjects.concat(
        this.productData.packageProjectsForGift
      )
      packageProjects = packageProjects.filter((obj) => {
        return (
          !this.mTransformList ||
          !this.mTransformList.list ||
          this.mTransformList.list.indexOf(obj.id) === -1
        )
      })
      if (this.showProject) {
        result = packageProjects
      } else {
        for (let i = 0; i < 2; i++) {
          if (packageProjects.length <= i) {
            break
          }
          result.push(packageProjects[i])
        }
      }
      console.log(packageProjects)
      return result
    },
    checkedProjectByRepeat () {
      let repeatProjects = {}
      this.checkedProjectByGroup.forEach((item) => {
        if (item.children && item.children.length > 0) {
          item.children.forEach((project) => {
            if (!repeatProjects[project.id]) {
              repeatProjects[project.id] = `${item.id}-${project.id}`
            }
          })
        }
      })
      return repeatProjects
    },
    fillUserInfo () {
      return this.$store.state.user.fillUserInfo
    }
  },
  methods: {
    closeDeleteRecommend (index, project) {
      if (!index) {
        if (this.delRecommendCode === 'deleteProject') {
          this.deleteProject(project, true)
        }
      }
      this.showDeleteRecommend = false
    },
    heckedProjectcs () {
      this.itThrough
        .filter((obj) => {
          return obj.select
        })
        .forEach((p) => {
          this.$store.commit('project/checkProject', p)
          this.$store.commit('project/setProductProjects')
          this.$store.commit('project/setCheckedMaterialProjectList')
        })
      this.showHistory = false
    },
    getHistoryProject (code) {
      var list = []
      this.historyProject.forEach((obj) => {
        if (
          !this.checkedProjectList.some((p) => {
            return p.id === obj.id
          })
        ) {
          let del = this.deleteList.find(($t) => {
            return $t.id === obj.id
          })
          let project = Object.assign(
            { select: false, code: '' },
            obj,
            del || {}
          )
          if (del) project.code = 'delete'
          list.push(project)
        }
      })
      this.itThrough = list.sort((a, b) => {
        return (
          ((b.code !== 'delete' && 1) || (b.code === 'delete' && b.star) || 0) -
          ((a.code !== 'delete' && 1) || (a.code === 'delete' && a.star) || 0)
        )
      })
      if (code) this.showHistory = !this.showHistory
    },
    selectDeleteProject (project) {
      project.select = !project.select
      // console.log(project);
    },
    closeHint07 (index) {
      if (index === 0) {
        this.closeHintCode07 = true
        this.isHint07 = false
        this.nextClicked()
      }
    },
    deleteProjectBtnClick (index, code) {
      if ((index === 1 && code) || index !== 1) {
        this.showDelectProject = false
        if (index === 1) {
          ///调用接口.....
          this.practicalCode = true
          this.nextClicked()
        } else {
          this.showHistory = true
        }
      }
    },
    lookExplain (code) {
      this.recordCode = code
      this.showDisclaimer = true
    },
    closeDisclaimer (code) {
      this.recordCode = code
      this.showDisclaimer = false
    },
    async closeHint (i) {
      if (this.btnList.length === 1 || i === 0 || i === 'mask') {
        this.addProject = []
        this.hintShow = false
      } else {
        if (i === 1) {
          await this.upProjectComputed()
          this.hintShow = false
          this.upgrade = true
          this.nextClicked()
        }
      }
    },
    upProjectComputed () {
      this.upProjectList.forEach((obj) => {
        let arr = this.projectList.filter((item) => {
          return obj.id === item.id
        })
        if (arr.length) {
          this.addMutex('', arr[0])
        }
      })
    },
    async getPrevious () {
      // 获取之前做的问卷
      Loading.show()
      let { data } = await this.$axios.get(BEFORE_QUESTION, {
        params: {
          type: 'x',
          marriageCode:
            this.fillUserInfo.marryStateCode || this.fillUserInfo.marriageCode,
          name: this.fillUserInfo.callName,
          sexCode: this.fillUserInfo.sexCode
        }
      })
      if (data.data !== null) {
        this.$router.push({
          name: 'questionDetails',
          params: { source: 'product', instanceId: data.data.instance.id }
        })
      } else {
        this.$router.push({
          name: 'physicalQuestionnaire',
          params: { source: 'product' }
        })
      }
      Loading.close()
    },
    addProjectClicked () {
      this.$store.commit('project/setCurrentClassGroupId', '')
      this.$router.push({ name: 'appointmentProject' })
    },
    jumpCurrentClassGroupClicked (id) {
      this.$store.commit('project/setCurrentClassGroupId', id)
      this.$router.push({ name: 'appointmentProject' })
    },
    hasRepeatProject (item) {
      let has = false
      item.children.forEach((project) => {
        if (
          this.checkedProjectByRepeat[project.id] !== `${item.id}-${project.id}`
        ) {
          has = true
        }
      })
      return has
    },
    getClassGroupPrice (item) {
      let price = 0
      item.children.forEach((project) => {
        if (
          this.checkedProjectByRepeat[project.id] === `${item.id}-${project.id}`
        ) {
          price += (project.price || 0).toString().movePoint(2)
        }
      })
      return price.toString().movePoint(-2)
    },
    showProjectDetail (project) {
      this.showProjectModal = true
      this.projectDetail = project
    },
    closeProjectDetail () {
      this.showProjectModal = false
    },
    getTime (data) {
      this.editDate = data.date
      this.affirmTime = data.time
      this.submit()
    },
    async specialHandler (date, specialProject) {
      Loading.show()
      await this.$store.commit(
        'project/checkProject',
        this.$store.state.project.checkedProjectList.find(
          (p) => p.id === specialProject.projectId
        )
      )
      await this.loadTestDate()
      Loading.close()
    },
    async loadTestDate () {
      let proIds = this.$store.state.project.checkedProjectList.map((p) => {
        return p.id
      })

      let params = {
        sysCenterId: this.$route.query.sysCenterId,
        proIds: proIds.join(',')
      }
      if (this.sysCenterId === '00-7') {
        let { data } = await this.$axios.get('/order/getDateRange.json', {
          params: params
        })
        let dateList = []
        if (data.beginDay && data.endDay) {
          var beginDay = new Date(data.beginDay)
          var endDay = new Date(data.endDay)
          while (endDay.getTime() - beginDay.getTime() >= 0) {
            var year = beginDay.getFullYear()
            var month =
              beginDay.getMonth().toString().length == 1
                ? '0' + (beginDay.getMonth() + 1).toString()
                : beginDay.getMonth() + 1
            var day =
              beginDay.getDate().toString().length == 1
                ? '0' + beginDay.getDate()
                : beginDay.getDate()
            dateList.push({
              code: '000',
              desc: '当前日期可以预约',
              testDate: year + '-' + month + '-' + day
            })
            beginDay.setDate(beginDay.getDate() + 1)
          }
        }
        this.dateList = dateList
      } else {
        let { data } = await this.$axios.get(TEST_DATE_BY_PROJECT, {
          params: params
        })
        let $this = this
        this.dateList = data.map((date) => {
          if (this.editDate === date.testDate) {
            if (date.specialProDtos.length > 0) {
              date.specialProDtos.map((specialProject) => {
                $this.hasOthers =
                  $this.$store.state.project.editProject.filter((obj) => {
                    return obj.projectId === specialProject.projectId
                  }).length <= 0
              })
            } else {
              date.code = '000'
              date.desc = ''
            }
          } else {
            date.specialProDtos = date.specialProDtos.map((specialProject) => {
              let project = $this.$store.state.project.checkedProjectList.find(
                (p) => p.id === specialProject.projectId
              )
              if (project) {
                specialProject.base = project.base
                specialProject.delectable = project.delectable
              }
              if (specialProject.delectable === '0') {
                date.code = specialProject.code
              }
              return specialProject
            })
          }
          return date
        })
      }
    },
    async edit () {
      if (this.deleteMode.custom || this.deleteMode.base) {
        this.deleteMode.custom = false
        this.deleteMode.base = false
      } else if (
        this.$store.state.project.checkedProjectList.length === 0 &&
        !this.$store.state.project.product.id
      ) {
        ToastMessage('请先选择体检内容，再进行下一步')
      } else {
        if (this.$route.query.type !== 'edit') await this.loadTestDate()
        if (this.hasOthers) {
          this.dateState = this.hasOthers
          return
        }
        this.submit()
      }
    },
    async submit () {
      Loading.show()
      let allProject = this.$store.state.project.checkedProjectList.map((p) => {
        return p.id
      })
      let recommendIdList = this.baseProjectList.map((obj) => {
        return obj.id
      }) // 原有
      //耗材
      let subData = {
        _BIZCODE: '0001',
        age: this.editData.age,
        autoBind: parseInt(this.editData.autoBind) || 1,
        boCellPhoneNo: this.$store.state.user.self.code,
        boExaminationDate: this.editData.boExaminationDateStr,
        boExaminationTime: this.editData.boExaminationTime,
        boExaminationTimeNo: this.editData.boExaminationTimeNo,
        // boExaminationDateStr: ,
        identityCardNo: this.editData.identityCardNo,
        mobile: '',
        name: this.editData.name,
        orderId: this.editData.id,
        orderNo: this.editData.orderNo,
        paymentType: this.editData.paymentCode,
        sexCode: this.editData.sexCode,
        sysCenterId: this.editData.sysCenterId,
        price: this.priceInfo.priceTotal,
        scope: 'paper',
        customIdList: [],
        recommendIdList: recommendIdList,
        packages: []
      }
      if (
        this.editData &&
        this.editData.packageId &&
        this.$route.query.type === 'edit'
      ) {
        subData.testPackageId = this.editData.packageId
        subData.replacedRelation = this.$store.state.project.productProjects.replacedRelation
        subData.scope = 'package'
      }
      if (this.editData && this.editData.grade && this.editData.gradeName) {
        subData.grade = this.editData.grade
        subData.gradeName = this.editData.gradeName
      }

      let num
      for (let materialProject of this.$store.state.project
        .checkedMaterialProjectList) {
        if (materialProject.recalculate === 0) {
          num = materialProject.count > 0 ? 1 : 0
        } else {
          num = materialProject.count
        }
        if (num > 0) {
          let arr = await this.ergodicArr(num, materialProject.id)
          subData.customIdList = subData.customIdList.concat(arr)
          // order.materialList.push({id: materialProject.id, num: num, recalculate: materialProject.recalculate})
        }
      }
      for (let project of this.$store.state.project.checkedProjectList) {
        if (
          project.base !== 1 &&
          project.packable !== 1 &&
          project.recommendable !== 1
        ) {
          subData.customIdList.push(project.id)
        } else if (
          !subData.recommendIdList.some((obj) => {
            return obj === project.id
          })
        ) {
          subData.recommendIdList.push(project.id)
        }
      }
      if (this.$route.params.id === 'pd') {
        subData.scope = 'package'
        let materialList = []
        subData.instanceId = this.$store.state.project.instanceId
        if (
          this.parckagemTransformListn.some((obj) => {
            return obj.reduce > 0
          }) ||
          (this.productProjects.packageProjectList &&
            this.productProjects.packageProjectList.length)
        ) {
          //或者无转换关系的关联项目
          this.parckagemTransformListn.forEach(async (obj) => {
            let customIdListArr = await this.ergodicArr(obj.num, obj.id)
            //                let packagesArr = await this.ergodicArr(obj.reduce, obj.id)
            if (subData.packages.indexOf(obj.parentId) === -1) {
              subData.packages.push(obj.parentId)
            }
            subData.customIdList = subData.customIdList.concat(customIdListArr)
          })
        }
        this.productProjects.replaced.projectList.forEach((obj) => {
          subData.packages.push(obj.id)
        })
      }
      let { data } = await this.$axios.post(UPDATE_ORDER_FORCLIENT, subData)
      ToastMessage('项目修改成功')
      this.$router.back()
      Loading.close()
    },
    ergodicArr (num, id) {
      let arr = []
      for (let i = 0; i < num; i++) {
        arr.push(id)
      }
      return arr
    },
    async nextClicked () {
      if (this.deleteMode.custom || this.deleteMode.base) {
        this.deleteMode.custom = false
        this.deleteMode.base = false
      } else if (
        this.$store.state.project.checkedProjectList.length === 0 &&
        !this.$store.state.project.product.id
      ) {
        ToastMessage('请先选择体检内容，再进行下一步')
      } else {
        if (this.sysCenter.id === '00-07' && !this.closeHintCode07) {
          this.isHint07 = true
          return
        } else {
          await this.getHistoryProject(false)
          if (!this.practicalCode && this.$route.params.type !== 'product') {
            let arrDelete = await this.getDeleteItem()
            if (arrDelete.length && this.sysCenter.disclaimer) {
              this.showDelectProject = true
              return
            }
          }
        }

        if (!this.upgrade && this.$route.params.type !== 'product') {
          this.getUpgrade()
          return
        }
        this.$router.push({
          path: '/appointment/submit?instanceId=' + this.$route.params.id
        })
      }
    },
    async getDeleteItem () {
      var arr = JSON.parse(JSON.stringify(this.myRecommendProject)) || [],
        idList = []
      console.log(this.itThrough)
      this.deleteProjects = arr.filter((obj) => {
        if (
          this.itThrough.some(($item) => {
            return $item.id === obj.id && $item.code === 'delete'
          })
        ) {
          idList.push(obj.id)
          return true
        }
      })
      var obj = Object.assign({}, this.schemeClass, { projectIdList: idList })
      this.$store.commit('project/setSchemeClass', obj)
      return this.deleteProjects
    },
    async getUpgrade () {
      Loading.show()
      let { data } = await this.$axios.get(
        '/center-service/v1/price/upgrades/' +
          this.$store.state.center.sysCenter.id
      )
      if (data && data.length) {
        this.upProjectList = []
        let name = ''
        let arr = ['=', '>=', '<=', '', '<', '>']
        for (let i = 0; i < data.length; i++) {
          let type = arr[data[i].matchType]
          if (
            (type === '' &&
              this.priceInfo.priceTotal > data[i].minValue &&
              this.priceInfo.priceTotal < data[i].maxValue) ||
            (type === '=' &&
              this.priceInfo.priceTotal === data[i].matchValue) ||
            (type === '>=' &&
              this.priceInfo.priceTotal >= data[i].matchValue) ||
            (type === '<=' &&
              this.priceInfo.priceTotal <= data[i].matchValue) ||
            (type === '<' && this.priceInfo.priceTotal < data[i].matchValue) ||
            (type === '>' && this.priceInfo.priceTotal > data[i].matchValue)
          ) {
            let selected = []
            data[i].upgradeExpress.split(',').forEach((obj) => {
              if (
                obj &&
                this.checkedProjectList.filter((item) => {
                  return item.id === obj.split('*')[0]
                }).length === 0
              ) {
                this.upProjectList.push({
                  num: obj.split('*')[1],
                  id: obj.split('*')[0]
                })
              }
            })
            if (type === '') {
              if (this.sysCenter.id === '00-07')
                name = `您的订单金额在<span style="color:#f25930;">${data[i].minValue}-${data[i].maxValue}</span>元之间,部分项目需要升级，才能更好的满足体检需求，请提前致电：<a href="tel:0532-82915853" class="buletive">0532-82915853</a>  或  <a href="tel:0532-82915852" class="buletive">0532-82915852</a>`
            else
                name = `您的订单金额在<span style="color:#f25930;">${data[i].minValue}-${data[i].maxValue}</span>元之间,部分项目需要升级，才能更好的满足体检需求`
            } else {
              let title = {
                '=': '为',
                '>=': '超过了',
                '<=': '少于',
                '<': '少于',
                '>': '超过了'
              }
              if (this.sysCenter.id === '00-07')
                name = `您的订单金额${title[type]}<span style="color:#f25930;">${data[i].matchValue}</span>元,为了更好满足您的体检需求，可享受我中心VIP服务，请提前致电：<a href="tel:0532-82915853" class="buletive">0532-82915853</a>、 <a href="tel:0532-82915852" class="buletive">0532-82915852</a> `
              else
                name = `您的订单金额${title[type]}<span style="color:#f25930;">${data[i].matchValue}</span>元,部分项目需要升级，才能更好的满足体检需求`
            }
            break
          }
        }
        Loading.close()
        if (this.upProjectList.length) {
          if(this.sysCenter.id === '00-07'){
            this.showTitle = '体检费用提示'
            this.btnList = ['再看看', '提前预约']
          }else {
            this.showTitle = '项目升级提示'
            this.btnList = ['再看看', '确定升级']
          }
          this.hintText = name
          this.hintShow = true
        } else {
          this.upgrade = true
          this.nextClicked()
        }
      } else {
        this.upgrade = true
        this.nextClicked()
      }
      Loading.close()
    },
    deleteClassGroupProject (item) {
      item.children.forEach((project) => {
        if (
          this.checkedProjectByRepeat[project.id] === `${item.id}-${project.id}`
        ) {
          this.deleteProject(project, true)
        }
      })
    },
    deleteModeClicked (mode) {
      this.deleteMode[mode] = !this.deleteMode[mode]
    },
    deleteProject (project, code) {
      if (this.recommendProjectList.length && !code) {
        let p = this.recommendProjectList.find((obj) => {
          return project.id === obj.id
        })
        if (p) {
          this.delRecommendCode = 'deleteProject'
          this.delRecommendProject = p
          this.showDeleteRecommend = true
          return
        }
      }
      this.$store.commit('project/checkProject', project)
      this.$store.commit('project/setProductProjects')
      this.$store.commit('project/setProjectPricingRules')
      this.$store.commit('project/setCheckedMaterialProjectList')
      this.delRecommendCode = ''
    },
    //      deleteBaseProject (project) {
    //        //删除基础项目包恢复加项
    //        this.$store.commit('project/checkProject', project)
    //        this.$store.commit('project/setProductProjects')
    //        this.$store.commit('project/setCheckedMaterialProjectList')
    //      },
    addMutex (project, addProject) {
      this.$store.commit('project/checkProject', addProject)
      this.$store.commit('project/setProductProjects')
      this.$store.commit('project/setCheckedMaterialProjectList')
    },
    revertBaseProject () {
      this.$store.commit('project/checkProject', this.revertProjectList[0])
      this.$store.commit('project/setProductProjects')
      this.$store.commit('project/setCheckedMaterialProjectList')
      this.$store.commit('project/removeRevertProject')
    },
    setProjectsAll () {},
    queryCheckedProjectList (id) {
      if (
        this.$store.state.project.checkedProjectList.filter((obj) => {
          return obj.id === id
        }).length > 0
      ) {
        return false
      } else {
        return true
      }
    }
  },
  async created () {
    this.editData = this.$store.state.project.editData
    if (
      this.$route.params.type === 'product' &&
      !this.$store.state.project.productProjects.priceTotal > 0
    ) {
    } else if (this.$route.params.type === 'customize') {
      this.$store.commit('project/setProduct', {})
      if (
        (!this.$store.state.project.recommendPackage ||
          (this.$store.state.project.recommendPackage &&
            !this.$store.state.project.recommendPackage.data)) &&
        !Object.keys(this.productData).length
      ) {
        this.$router.go(-1)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style ref="stylesheet/scss" lang="scss" scoped>
@import "@/assets/style/variables.scss";

.affix-block,
.vue-affix {
  height: 50px;
  width: 100%;
}

.affix-bottom,
.affix-top,
.affix {
  background: #f6f6f6;
  z-index: 5;
}

.m-page {
  padding-bottom: 50px;
  font-size: 16px;
}

.m-title {
  width: 100%;
  height: 48px;
  line-height: 48px;
  padding: 0 15px;
  &:before {
    content: " ";
    width: 4px;
    height: 14px;
    background: #f25930;
    position: absolute;
    top: 50%;
    margin-top: -7px;
    left: 10px;
  }
  span {
    font-size: 15px;
    padding-left: 10px;
    color: #666666;
    &:before {
      display: inline-block;
      width: 2px;
      height: 16px;
      background-color: $assertive;
      vertical-align: text-bottom;
    }
  }
  .m-btn {
    float: right;
    button {
      width: 70px;
      height: 26px;
      line-height: 18px;
      padding: 0 15px;
      margin-left: 10px;
      border-radius: 15px;
      background-color: none;
      border:1px solid $dark09;
      font-size: 15px;
      color: $dark09;
    }
    .assertive {
      border-color: $assertive;
      color: $assertive !important;
      /*color: #006834;*/
    }
    .btn-done {

      color: $assertive !important;
      border-color: $assertive;
    }
  }
}

.m-basics {
  display: flex;
  width: 100%;
  height: 50px;
  line-height: 50px;
  padding-left: 15px;
  background-color: #ffffff;
  .m-radio {
    width: 40px;
  }
  .m-cont {
    display: flex;
    flex: 1;
    justify-content: space-between;
    border-bottom: 1px solid #f6f6f6;
  }
}

.item-main {
  padding-left: 15px;
  border-bottom: 1px solid #f5f5f5;
}

.m-optional .item-main .warning-info {
  font-size: 16px !important;
  margin-left: 0;
  margin-bottom: 14px;
}

.m-optional {
  background-color: #ffffff;
  .warning-info {
    margin: 0 15px 5px 15px;
  }
  .m-optional {
    border-left: 2px solid $assertive;
    margin-left: 14px;
    background-color: #f3f9ff;
    .m-item .m-hot {
      background-color: $assertive;
      border: 1px solid $assertive;
      color: #fff;
    }
  }
  .border-bottom {
    border-bottom: 1px solid #f5f5f5;
  }
  .m-item {
    display: flex;
    flex: 1;
    justify-content: space-between;
    width: 100%;
    height: 44px;
    line-height: 44px;
    &.del-line .m-text {
      color: #999;
      text-decoration: line-through;
    }
    > div {
      display: flex;
      align-items: center;
      width: 270px;
    }
    em {
      font-style: normal;
      display: inline-block;
    }
    .icon-del2 {
      color: red;
      margin-right: 5px;
    }
    .icon-arrow-right {
      padding-left: 8px;
      padding-right: 5px;
      margin-right: 0;
      font-size: 14px;
      color: #999999;
    }
    .m-text-box {
      display: flex;
      flex: 0 0 240px;
      height: 100%;
    }
    .m-text {
      max-width: 180px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 16px;
      color: #333333;
    }
    &.no-recommend .m-text {
      flex: 1;
    }

    .m-hot {
      flex: 0 0 45px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      margin-left: 6px;
      margin-top: 6px;
      font-size: 10px;
      border: 1px solid $assertive;
      border-radius: 10px 10px 10px 0;
      color: $assertive;
      &.mode-delete {
        margin-left: 0;
      }
    }
    .m-num {
      width: 100px;
      text-align: right;
      display: inline-block;
      span {
        font-size: 12px;
        color: #999999;
      }
    }
    &.m-item-alert {
      justify-content: center;
      .m-text {
        color: #999;
      }
    }
  }
}

.m-optional {
  .group-text {
    position: relative;
    width: 220px;
    margin-left: 14px;
    & > em {
      margin-left: 10px;
    }
    .m-text {
      padding-left: 14px;
      color: #3787ea;
    }
    &:before {
      content: " ";
      position: absolute;
      top: 35px;
      bottom: 0px;
      left: 0;
      height: 20px;
      border-left: 2px solid #3787ea;
    }
    img {
      width: 25px !important;
    }
  }
  .m-item .group-price {
    width: 205px;
    span {
      font-size: 15px;
      color: #3787ea !important;
    }
  }
}

.m-foot {
  display: flex;
  flex: 1;
  position: fixed;
  z-index: 10;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 50px;
  line-height: 50px;
  background-color: #ffffff;
  border-top: 1px solid #f5f5f5;
  .m-info {
    display: flex;
    flex: 1;
    padding-left: 15px;
    .m-info-left {
      flex: 1;
      font-size: 14px;
      > span {
        font-size: 12px;
        color: $assertive;
        > b {
          font-size: 24px;
        }
      }
    }
    .m-info-right {
      width: 80px;
      text-align: center;
      > i {
        padding: 0 10px;
      }
    }
  }
  .m-next {
    width: 110px;
    text-align: center;
    background-color: $assertive;
    font-size: 18px;
    color: #ffffff;
  }
  .btn-done {
    background-color: #3787ea;
    color: #fff;
    border-color: #3787ea;
  }
}

.m-total {
  font-weight: bold;
  font-size: 20px;
  color: $assertive;
  align-items: center;
  position: relative;
  width: 100%;
  height: 44px;
  padding: 10px 10px 0 0;
  text-align: right;
  span.title {
    color: #999;
    font-size: 14px;
    font-weight: normal;
  }
  span.tag {
    font-size: 12px;
  }
}

.m-group {
  margin-bottom: 20px;
}

/*套餐*/
.item {
  padding: 0 0 0 15px;
}

.item /deep/ .item-content {
  padding: 10px 0;
  color: $dark;
  border-bottom: 1px solid $darkEEE;
}

.productReplace /deep/ .item-content {
  color: $dark09;
  text-decoration: line-through;
}

.showProject /deep/ .item-content {
  text-align: center;
  padding: 13px 0;
}

.productName /deep/ .item-content {
  border-bottom: 1px solid $darkEEE;
  padding: 15px 10px 15px 0;
  display: flex !important;
  align-items: center;
  h2 {
    font-weight: 600;
  }
  span {
    flex: 0 0 auto;
    color: $assertive;
    font-weight: bold;
    font-size: 12px;
  }
  i {
    font-size: 18px;
  }
  div {
    flex: 1;
    display: flex;
    align-items: center;
  }
  img {
    margin-right: 10px;
    width: 30px;
  }
}

.inquiry {
  margin: 30px 0;
  text-align: center;
  color: $dark09;
  span {
    font-size: 15px;
    color: $assertive;
    text-decoration: underline;
  }
}

.consumable-show {
  padding-left: 0px;
  .item /deep/ .item-content {
    padding: 8px 0;
    padding-right: 30px;
  }
}

.historyProjectBox /deep/ {
  height: 400px;
  border-radius: 8px 8px 0 0;
  /*padding: 0 15px 0;*/
  background: $light !important;
  .van-actionsheet__header {
    font-weight: 600;
    background: $light !important;
    margin-bottom: 5px;
  }
  .projectBox {
    overflow-x: hidden;
    height: 280px;
    overflow-y: auto;
    padding: 10px 0;
    .col-12 {
      width: 0px;
    }
    .no-recommend {
      padding-right: 10px;
    }
  }
  .projectItem {
    line-height: 2;
    padding: 8px 15px;
    border-bottom: 1px solid #dddddd;
    em {
      margin-right: 5px;
    }
    .recommendationLevel {
      font-size: 14px;
      color: red;
    }
  }
  .notDelete {
    font-size: 14px;
    border: 1px solid red;
    color: red;
    margin-left: 15px;
    padding: 0 10px;
  }
  .btns {
    width: 100%;
    position: absolute;
    bottom: 0px;
    padding: 5px 20px 15px 20px;
    button {
      flex: 0 0 46%;
      padding: 8px 15px;
      color: $light;
      border: none;
      border-radius: 6px;
    }
    .close {
      background: $dark09;
    }
  }
}

.historyProject {
  position: fixed;
  bottom: 60px;
  z-index: 999;
  right: 15px;
  font-size: 28px;
  color: $dark09;
  border: 1px solid $dark09;
  border-radius: 40px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  background: #eeeeee;
  width: 40px;
}
.hasq {
  font-size: 14px;
  margin-left: 14px;
  border-left: 2px solid #3787ea;
  padding-left: 10px;
  line-height: 1.5;
  color: $dark09;
  /*<!--background: $assertive;-->*/
  /*<!--color: $light;-->*/
  /*<!--display: inline-block;-->*/
  /*<!--!*line-height: 30px;*!-->*/
  /*<!--border-radius: 5px;-->*/
  /*<!--margin-right: 5px;-->*/
  /*<!--padding: 4px 10px;-->*/
}
.icon-iconfontquestion {
  font-size: 20px;
  position: relative;
  top: 3px;
}
</style>
